import PositionsGridCard from "./PositionsGridCard";

export default function PositionsGrid({
  rows,
  closingPositionId,
  onEdit,
  onClose,
}) {
  return (
    <div className="w-full min-h-0 flex-1 flex flex-col gap-4 overflow-y-auto mb:hidden">
      {rows.map((row) => (
        <PositionsGridCard
          key={row.id}
          {...row}
          isClosing={closingPositionId === String(row.id)}
          onEdit={() => onEdit(row)}
          onClose={onClose}
        />
      ))}
    </div>
  );
}
